export default {
  locale: "en",
  name: "Close Travel Window",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
      },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeTravel",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
